import { Action } from "@ngrx/store";
import { Job, PipeProgress, PipeStatus } from "./job.model";

export enum JobActionTypes {
  LoadJobs = "[Job] Load Jobs",
  LoadJobsSuccess = "[Job] Load Jobs Success",
  LoadJobsFailure = "[Job] Load Jobs Failure",
  UpdateJobStatus = "[Job] Update Job Status",
  UpdateJobProgress = "[Job] Update Job Progress",
}

export class LoadJobs implements Action {
  readonly type = JobActionTypes.LoadJobs;
  constructor() {}
}

export class LoadJobsSuccess implements Action {
  readonly type = JobActionTypes.LoadJobsSuccess;
  constructor(public jobs: Job[]) {}
}

export class LoadJobsFailure implements Action {
  readonly type = JobActionTypes.LoadJobsFailure;
  constructor(public error: any) {}
}

export class UpdateJobStatus implements Action {
  readonly type = JobActionTypes.UpdateJobStatus;
  constructor(
    public job: Job,
    public status: PipeStatus,
  ) {}
}

export class UpdateJobProgress implements Action {
  readonly type = JobActionTypes.UpdateJobProgress;
  constructor(
    public job: Job,
    public pipe: string,
    public progress: PipeProgress,
    public payload: any,
  ) {}
}

export type JobActions =
  | LoadJobs
  | LoadJobsSuccess
  | LoadJobsFailure
  | UpdateJobStatus
  | UpdateJobProgress;
